var map = {
	"./f_junior.svg": 89802,
	"./f_junior_masque.svg": 42861,
	"./f_senior.svg": 38489,
	"./f_senior_masque.svg": 56568,
	"./h_junior.svg": 97804,
	"./h_junior_masque.svg": 56131,
	"./h_senior.svg": 66131,
	"./h_senior_masque.svg": 79798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55136;